// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:772px){.snackbar[data-v-6b767e29]{left:50%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
